import ProfileAvailability from "@/pages/profiel/Availability"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/beschikbaarheid")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileAvailability />
}
